import { render, staticRenderFns } from "./CertIconSVG.vue?vue&type=template&id=9ae833c8&"
import script from "./CertIconSVG.vue?vue&type=script&lang=js&"
export * from "./CertIconSVG.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports